import { type AxiosResponse } from "axios";

import ApiClient from "shared/services/api/ApiClient";
import { type Nullable } from "shared/types";

export type AIUserContextTone =
  | "confident"
  | "default"
  | "enthusiastic"
  | "formal"
  | "neutral"
  | "persuasive"
  | "supportive"
  | "witty_humorous";

export interface AIUserContext {
  competitors: string;
  goals: string;
  keyMessages: string;
  organisationName: string;
  role: string;
  tone: AIUserContextTone;
}

export interface AIUserContextParams extends AIUserContext {
  beta?: boolean;
}

export interface AIUserContextApiError {
  error_fields: string[];
  error_type: Nullable<
    | "override_attempt"
    | "jailbreak_attempt"
    | "content_violation"
    | "obfuscation"
    | "structural_injection"
  >;
  reason: string;
  success: boolean;
  user_context_error?: boolean;
}

class AIUserContextService extends ApiClient {
  constructor() {
    super("/ai/user_context");
  }

  load(): Promise<AxiosResponse<AIUserContext>> {
    return this.get("/", { transformKeys: true });
  }

  remove(): Promise<AxiosResponse<AIUserContext>> {
    return this.delete("/", { transformKeys: true });
  }

  save(data: AIUserContextParams): Promise<AxiosResponse<AIUserContext>> {
    return this.put("/update", { data, transformKeys: true });
  }
}

export default new AIUserContextService();
